export const legal = {
  // Navigation
  home: 'Accueil',
  legalNotice: 'Mentions légales',
  privacyPolicy: 'Politique de confidentialité',
  cookiePolicy: 'Politique des cookies',
  termsOfUse: 'Conditions d\'utilisation',
  dataProtection: 'Protection des données',
  otherLegalInfo: 'Autres informations légales',
  
  // Common
  lastUpdated: 'Dernière mise à jour',
  effectiveDate: 'Date d\'entrée en vigueur',
  company: 'Société',
  vat: 'N° TVA',
  address: 'Adresse',
  phone: 'Téléphone',
  email: 'E-mail',
  website: 'Site web',
  contact: 'Contact',
  contactUs: 'Nous contacter',
  contactUsText: 'Pour toute question concernant nos mentions légales',
  
  // ========== MENTIONS LÉGALES ==========
  legalNoticeTitle: 'Mentions Légales',
  legalNoticeDescription: 'Informations légales conformes à la législation belge et européenne',
  
  // Éditeur du site
  sitePublisher: 'Éditeur du Site',
  legalForm: 'Forme juridique',
  individualCompany: 'Entreprise individuelle',
  headquarters: 'Siège social',
  publicationManager: 'Responsable de la publication',
  
  // Numéro d\'entreprise BCE
  bceNumber: 'Numéro d\'entreprise BCE',
  bceRegistry: 'Registre des entreprises',
  brussels: 'Bruxelles',
  
  // Assurance professionnelle
  professionalInsurance: 'Assurance responsabilité professionnelle',
  insuranceCompany: 'Compagnie d\'assurance',
  insuranceNote: 'Ktran dispose d\'une assurance responsabilité civile professionnelle couvrant ses activités de rénovation et construction.',
  
  // Heures d\'ouverture
  businessHours: 'Heures d\'ouverture',
  mondayFriday: 'Lundi - Vendredi',
  saturday: 'Samedi',
  sunday: 'Dimanche',
  closed: 'Fermé',
  byAppointment: 'Sur rendez-vous',
  
  // Hébergement
  siteHosting: 'Hébergement du Site',
  host: 'Hébergeur',
  hostingLocation: 'Localisation',
  europeanUnion: 'Union Européenne',
  hostingNote: 'Le site est hébergé sur une infrastructure cloud sécurisée conforme aux normes européennes de protection des données (RGPD).',
  
  // Propriété intellectuelle
  intellectualProperty: 'Propriété Intellectuelle',
  intellectualPropertyText1: 'L\'ensemble des éléments de ce site (structure, textes, images, logos, vidéos, etc.) sont la propriété exclusive de Ktran ou font l\'objet d\'une autorisation d\'utilisation.',
  intellectualPropertyText2: 'Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de Ktran.',
  intellectualPropertyText3: 'Les marques, logos et signes distinctifs reproduits sur ce site sont des marques déposées de Ktran. Toute reproduction totale ou partielle de ces marques ou logos sans autorisation préalable et écrite de Ktran est interdite.',
  exception: 'Exception',
  exceptionText: 'Les utilisateurs sont autorisés à consulter et imprimer les pages du site pour un usage strictement personnel et privé, non commercial.',
  
  // Responsabilité
  limitationOfLiability: 'Limitation de Responsabilité',
  liabilityText1: 'Ktran met tout en œuvre pour assurer l\'exactitude et la mise à jour des informations publiées sur ce site. Toutefois, Ktran ne peut garantir l\'exactitude, la précision ou l\'exhaustivité des informations disponibles sur ce site.',
  liabilityText2: 'En conséquence, Ktran décline toute responsabilité pour :',
  liabilityList1: 'Toute imprécision, inexactitude ou omission portant sur des informations disponibles sur le site',
  liabilityList2: 'Tout dommage résultant d\'une intrusion frauduleuse d\'un tiers ayant entraîné une modification des informations',
  liabilityList3: 'Tout dommage direct ou indirect causé à l\'utilisateur, quelle qu\'en soit la nature, résultant du contenu, de l\'accès ou de l\'utilisation du site',
  liabilityList4: 'L\'utilisation du site par l\'utilisateur et les conséquences pouvant en découler',
  liabilityList5: 'Les interruptions ou dysfonctionnements du site',
  liabilityList6: 'Les virus informatiques ou autres éléments nuisibles',
  liabilityNote: 'Ktran se réserve le droit de modifier ou de corriger le contenu de ce site à tout moment et sans préavis.',

  // Liens hypertextes
  hyperlinks: 'Liens Hypertextes',
  hyperlinksText1: 'Le site peut contenir des liens hypertextes vers d\'autres sites internet. Ktran n\'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.',
  hyperlinksText2: 'La création de liens hypertextes vers le site ktran.be nécessite une autorisation écrite préalable de Ktran. Cette autorisation peut être révoquée à tout moment.',
  
  // Droit applicable
  applicableLaw: 'Droit Applicable et Juridiction Compétente',
  applicableLawText1: 'Les présentes mentions légales sont régies par le droit belge et européen.',
  applicableLawText2: 'En cas de litige et à défaut d\'accord amiable, le litige sera porté devant les tribunaux compétents de Bruxelles, Belgique.',
  
  // Conformité RGPD
  gdprCompliance: 'Conformité RGPD',
  gdprComplianceText: 'Ce site est conforme au Règlement Général sur la Protection des Données (RGPD) de l\'Union Européenne (UE 2016/679). Pour plus d\'informations sur la protection de vos données personnelles, consultez notre Politique de Confidentialité.',
  

  // ========== POLITIQUE DE CONFIDENTIALITÉ ==========
  privacyPolicyTitle: 'Politique de Confidentialité',
  privacyPolicyDescription: 'Protection de vos données personnelles conformément au RGPD',
  
  // Introduction
  privacyCommitment: 'Notre Engagement envers Votre Vie Privée',
  privacyCommitmentText: 'Ktran (N° TVA : BE0729535515) s\'engage à protéger la vie privée de ses utilisateurs et clients. Cette politique de confidentialité explique comment nous collectons, utilisons, stockons et protégons vos données personnelles conformément au Règlement Général sur la Protection des Données (RGPD - UE 2016/679) et à la législation belge.',
  
  // Responsable du traitement
  dataController: 'Responsable du Traitement des Données',
  enterprise: 'Entreprise',
  dpoContact: 'Contact Délégué à la Protection des Données (DPO)',
  dpoEmail: 'Pour toute question relative à la protection de vos données',
  
  // Données collectées
  personalDataCollected: 'Données Personnelles Collectées',
  personalDataIntro: 'Nous collectons uniquement les données strictement nécessaires à la fourniture de nos services :',
  
  identificationData: '1. Données d\'Identification',
  nameAndSurname: 'Nom et prénom',
  emailAddress: 'Adresse e-mail',
  phoneNumber: 'Numéro de téléphone',
  postalAddress: 'Adresse postale (code postal et commune)',
  
  projectData: '2. Données relatives aux Projets',
  desiredWorkType: 'Type de travaux souhaités',
  housingType: 'Type de logement',
  projectDescription: 'Description du projet',
  projectPhotos: 'Photos du projet (si fournies)',
  estimatedBudget: 'Budget estimé',
  desiredDeadline: 'Délai souhaité',
  
  navigationData: '3. Données de Navigation',
  ipAddress: 'Adresse IP',
  browserType: 'Type de navigateur',
  pagesVisited: 'Pages visitées',
  visitDateTime: 'Date et heure de visite',
  cookies: 'Cookies (voir Politique des Cookies)',
  
  // Finalités du traitement
  processingPurposes: 'Finalités du Traitement',
  processingPurposesText: 'Vos données personnelles sont collectées et traitées pour les finalités suivantes :',
  
  quoteManagement: '📋 Gestion des Demandes de Devis',
  quoteManagementDesc: 'Traiter et répondre à vos demandes de devis pour des travaux de rénovation',
  
  clientCommunication: '📞 Communication avec les Clients',
  clientCommunicationDesc: 'Vous contacter pour discuter de votre projet et assurer le suivi',
  
  serviceImprovement: '📊 Amélioration des Services',
  serviceImprovementDesc: 'Analyser l\'utilisation du site pour améliorer nos services',
  
  legalObligations: '⚖️ Obligations Légales',
  legalObligationsDesc: 'Respecter nos obligations légales et comptables',
  
  // Base légale
  legalBasis: 'Base Légale du Traitement',
  legalBasisText: 'Le traitement de vos données personnelles repose sur les bases légales suivantes :',
  
  consent: '✓ Consentement',
  consentText: 'Vous consentez au traitement de vos données en soumettant le formulaire de demande de devis',
  
  contractExecution: '✓ Exécution du Contrat',
  contractExecutionText: 'Le traitement est nécessaire à l\'exécution d\'un contrat de prestation de services',
  
  legitimateInterest: '✓ Intérêt Légitime',
  legitimateInterestText: 'Amélioration de nos services et communication commerciale',
  
  legalObligation: '✓ Obligation Légale',
  legalObligationText: 'Conservation des données pour respecter les obligations comptables et fiscales belges',
  
  // Durée de conservation
  retentionPeriod: 'Durée de Conservation des Données',
  retentionPeriodText: 'Vos données personnelles sont conservées pendant les durées suivantes :',
  
  dataType: 'Type de Données',
  retentionDuration: 'Durée de Conservation',
  
  quoteRequests: 'Demandes de devis (prospects)',
  threeYears: '3 ans après le dernier contact',
  
  clientData: 'Données clients (contrat signé)',
  tenYears: '10 ans (obligations comptables belges)',
  
  navigationDataCookies: 'Données de navigation (cookies)',
  thirteenMonthsMax: '13 mois maximum',
  
  projectPhotosData: 'Photos de projets',
  projectDurationPlusThree: 'Durée du projet + 3 ans',
  
  retentionNote: 'À l\'expiration de ces délais, vos données sont supprimées de manière sécurisée ou anonymisées.',
  
  // Droits des utilisateurs
  yourRights: 'Vos Droits sur Vos Données',
  yourRightsText: 'Conformément au RGPD, vous disposez des droits suivants :',
  
  rightOfAccess: '✅ Droit d\'Accès',
  rightOfAccessDesc: 'Obtenir une copie de vos données personnelles',
  
  rightOfRectification: '✏️ Droit de Rectification',
  rightOfRectificationDesc: 'Corriger vos données inexactes ou incomplètes',
  
  rightToErasure: '🗑️ Droit à l\'Effacement',
  rightToErasureDesc: 'Demander la suppression de vos données ("droit à l\'oubli")',
  
  rightToRestriction: '⏸️ Droit à la Limitation',
  rightToRestrictionDesc: 'Limiter le traitement de vos données',
  
  rightToPortability: '📦 Droit à la Portabilité',
  rightToPortabilityDesc: 'Recevoir vos données dans un format structuré',
  
  rightToObject: '🚫 Droit d\'Opposition',
  rightToObjectDesc: 'Vous opposer au traitement de vos données',
  
  rightAutomatedDecisions: '🤖 Droit relatif aux Décisions Automatisées',
  rightAutomatedDecisionsDesc: 'Ne pas faire l\'objet d\'une décision fondée exclusivement sur un traitement automatisé',
  
  // Exercice des droits
  howToExerciseRights: 'Comment Exercer Vos Droits ?',
  howToExerciseRightsText: 'Pour exercer l\'un de ces droits, contactez-nous :',
  
  byEmail: '📧 Par e-mail',
  byPhone: '📞 Par téléphone',
  byMail: '✉️ Par courrier',
  
  informationToProvide: 'Informations à fournir',
  yourNameSurname: '• Votre nom et prénom',
  yourEmail: '• Votre adresse e-mail',
  requestNature: '• La nature de votre demande (accès, rectification, effacement, etc.)',
  idCopy: '• Une copie de votre pièce d\'identité (pour vérification)',
  
  responseDeadline: '⏱️ Délai de Réponse',
  responseDeadlineText: 'Nous nous engageons à répondre à votre demande dans un délai maximum d\'un mois à compter de sa réception. Ce délai peut être prolongé de deux mois en cas de demande complexe.',
  
  freeOfCharge: '💰 Gratuité',
  freeOfChargeText: 'L\'exercice de vos droits est gratuit. Toutefois, en cas de demandes manifestement infondées ou excessives, nous pourrions exiger le paiement de frais raisonnables.',
  
  // Sécurité des données
  dataSecurity: 'Sécurité des Données',
  dataSecurityText: 'Ktran met en œuvre toutes les mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre :',
  
  accidentalDestruction: '• La destruction accidentelle ou illicite',
  accidentalLoss: '• La perte accidentelle',
  unauthorizedAccess: '• L\'altération, la diffusion ou l\'accès non autorisés',
  illegalProcessing: '• Toute autre forme de traitement illicite',
  
  securityMeasures: '🔒 Mesures de Sécurité Mises en Place',
  sslEncryption: '✓ Chiffrement SSL/TLS de toutes les communications',
  gdprHosting: '✓ Hébergement sécurisé conforme RGPD',
  restrictedAccess: '✓ Accès restreint aux données (authentification)',
  regularBackups: '✓ Sauvegardes régulières et sécurisées',
  incidentMonitoring: '✓ Surveillance et détection des incidents',
  
  // Partage des données
  dataSharing: 'Partage des Données',
  dataSharingText1: 'Ktran ne vend, ne loue ni ne partage vos données personnelles avec des tiers à des fins commerciales.',
  dataSharingText2: 'Vos données peuvent être partagées uniquement dans les cas suivants :',
  
  serviceProviders: '🔧 Prestataires de Services',
  serviceProvidersDesc: 'Hébergement web (Vercel), service e-mail transactionnel (Resend), conformes RGPD',
  
  legalObligationsSharing: '⚖️ Obligations Légales',
  legalObligationsSharingDesc: 'Autorités judiciaires ou administratives en cas de demande légale',
  
  subcontractors: '👷 Sous-traitants',
  subcontractorsDesc: 'Uniquement si nécessaire pour l\'exécution de votre projet (avec accord contractuel de confidentialité)',
  
  euLocation: '🇪🇺 Tous nos prestataires sont situés dans l\'Union Européenne ou garantissent un niveau de protection équivalent au RGPD.',
  
  // Transferts internationaux
  internationalTransfers: 'Transferts Internationaux de Données',
  internationalTransfersText: 'Vos données personnelles sont hébergées et traitées au sein de l\'Union Européenne. Aucun transfert vers des pays tiers n\'est effectué sans garanties appropriées (clauses contractuelles types de la Commission européenne, décision d\'adéquation).',
  
  // Droit de réclamation
  rightToComplain: 'Droit d\'Introduire une Réclamation',
  rightToComplainText: 'Si vous estimez que le traitement de vos données personnelles constitue une violation du RGPD, vous avez le droit d\'introduire une réclamation auprès de l\'autorité de contrôle belge :',
  
  dataProtectionAuthority: 'Autorité de Protection des Données (APD)',
  apdAddress: '📍 Adresse',
  apdAddressText: 'Rue de la Presse 35, 1000 Bruxelles, Belgique',
  apdContact: '📞 Contact',
  apdPhone: 'Téléphone : +32 2 274 48 00',
  apdEmail: 'E-mail : contact@apd-gba.be',
  apdWebsite: '🌐 Site web',
  apdWebsiteUrl: 'www.autoriteprotectiondonnees.be',
  
  // Modifications de la politique
  policyModifications: 'Modifications de la Politique',
  policyModificationsText: 'Ktran se réserve le droit de modifier cette politique de confidentialité à tout moment. Toute modification sera publiée sur cette page avec une nouvelle date de mise à jour. Nous vous encourageons à consulter régulièrement cette page pour rester informé de la manière dont nous protégeons vos données.',
  
  // Mineurs
  minorsData: 'Données des Mineurs',
  minorsDataText: 'Nos services ne sont pas destinés aux personnes de moins de 16 ans. Si vous avez moins de 16 ans, vous devez obtenir le consentement de vos parents ou tuteurs légaux avant de nous fournir des données personnelles. Si nous découvrons que nous avons collecté des données d\'un mineur sans consentement parental, nous supprimerons ces données dans les plus brefs délais.',

  // ========== CONDITIONS D'UTILISATION ==========
  termsOfUseTitle: 'Conditions d\'Utilisation',
  termsOfUseDescription: 'Conditions générales d\'utilisation du site ktran.be',
  
  // Acceptation des conditions
  acceptanceOfTerms: 'Acceptation des Conditions',
  acceptanceText: 'En accédant et en utilisant le site ktran.be (ci-après dénommé "le Site"), vous acceptez de vous conformer aux présentes conditions générales d\'utilisation. Si vous n\'acceptez pas ces conditions, veuillez ne pas utiliser ce site.',
  
  // Objet
  purpose: 'Objet',
  purposeText1: 'Les présentes Conditions Générales d\'Utilisation (CGU) ont pour objet de définir les modalités et conditions d\'utilisation du Site, ainsi que les droits et obligations des utilisateurs et de Ktran.',
  purposeText2: 'Le Site est édité par :',
  
  // Accès au site
  siteAccess: 'Accès au Site',
  siteAccessText1: 'Le Site est accessible gratuitement à tout utilisateur disposant d\'un accès à Internet. Tous les coûts supportés par l\'utilisateur pour accéder au service (matériel informatique, logiciels, connexion Internet, etc.) sont à sa charge.',
  siteAccessText2: 'Ktran met en œuvre tous les moyens raisonnables à sa disposition pour assurer un accès de qualité au Site, mais n\'est tenue à aucune obligation d\'y parvenir.',
  
  serviceInterruptions: '⚠️ Interruptions de Service',
  serviceInterruptionsText: 'Ktran se réserve le droit d\'interrompre, de suspendre momentanément ou de modifier sans préavis l\'accès à tout ou partie du Site, notamment pour des raisons de maintenance, de mise à jour ou pour toute autre raison technique, sans que l\'interruption n\'ouvre droit à aucune obligation ni indemnisation.',
  
  // Services proposés
  servicesOffered: 'Services Proposés',
  servicesOfferedText1: 'Le Site a pour objet de fournir des informations sur les services de rénovation proposés par Ktran et de permettre aux utilisateurs de :',
  servicesOfferedList1: 'Consulter les services de rénovation disponibles',
  servicesOfferedList2: 'Découvrir les projets réalisés',
  servicesOfferedList3: 'Soumettre des demandes de devis en ligne',
  servicesOfferedList4: 'Contacter l\'entreprise pour obtenir des informations',
  servicesOfferedNote: 'Ktran s\'efforce de fournir des informations aussi précises que possible. Toutefois, elle ne pourra être tenue responsable des omissions, des inexactitudes et des carences dans la mise à jour, qu\'elles soient de son fait ou du fait des tiers partenaires qui lui fournissent ces informations.',
  
  // Obligations de l'utilisateur
  userObligations: 'Obligations de l\'Utilisateur',
  userObligationsText: 'L\'utilisateur s\'engage à utiliser le Site conformément aux présentes CGU et à la législation en vigueur. Il est notamment interdit de :',
  
  prohibitedUses: '🚫 Utilisations Interdites',
  prohibitedUsesList1: '• Utiliser le Site à des fins illégales ou frauduleuses',
  prohibitedUsesList2: '• Porter atteinte aux droits de propriété intellectuelle de Ktran',
  prohibitedUsesList3: '• Publier du contenu illégal, diffamatoire ou offensant',
  prohibitedUsesList4: '• Tenter d\'accéder de manière non autorisée au système informatique',
  prohibitedUsesList5: '• Perturber le fonctionnement normal du Site',
  prohibitedUsesList6: '• Collecter des données personnelles d\'autres utilisateurs',
  prohibitedUsesList7: '• Utiliser des robots, scripts ou autres moyens automatisés',
  
  userObligationsText2: 'L\'utilisateur s\'engage à fournir des informations exactes et à jour lors de la soumission de formulaires. Toute fausse déclaration peut entraîner le rejet de la demande.',
  
  // Demandes de devis
  quoteRequestsSection: 'Demandes de Devis',
  quoteRequestsText1: 'Les demandes de devis soumises via le Site sont gratuites et sans engagement. Elles permettent à Ktran d\'évaluer votre projet et de vous proposer une offre personnalisée.',
  
  requestProcess: '📋 Processus de Demande',
  requestProcessStep1: '1. Remplissage du formulaire en ligne avec les détails de votre projet',
  requestProcessStep2: '2. Soumission de la demande (avec photos optionnelles)',
  requestProcessStep3: '3. Réception et analyse de votre demande par Ktran',
  requestProcessStep4: '4. Contact par e-mail ou téléphone pour discuter du projet',
  requestProcessStep5: '5. Établissement d\'un devis détaillé (sous 48-72h ouvrables)',
  
  important: 'Important',
  quoteRequestsNote: 'La soumission d\'une demande de devis ne constitue pas un engagement contractuel. Le devis fourni par Ktran est valable 30 jours à compter de sa date d\'émission, sauf mention contraire.',
  
  // Droit de rétractation (consommateurs)
  rightOfWithdrawal: 'Droit de Rétractation (Consommateurs)',
  rightOfWithdrawalText: 'Conformément au Code de droit économique belge (Livre VI), les consommateurs disposent d\'un délai de 14 jours calendrier pour se rétracter d\'un contrat conclu à distance, sans devoir justifier de motifs ni payer de pénalités.',
  
  withdrawalPeriod: '📅 Délai de Rétractation',
  withdrawalPeriodText: 'Le délai de rétractation expire 14 jours après la conclusion du contrat de services. Pour exercer ce droit, vous devez nous notifier votre décision de rétractation par une déclaration dénuée d\'ambiguïté.',
  
  withdrawalForm: '📝 Formulaire de Rétractation',
  withdrawalFormText: 'Vous pouvez utiliser le formulaire type de rétractation disponible sur demande ou toute autre déclaration dénuée d\'ambiguïté.',
  
  withdrawalException: '⚠️ Exception',
  withdrawalExceptionText: 'Le droit de rétractation ne s\'applique pas si les travaux ont commencé avec votre accord exprès avant la fin du délai de 14 jours.',
  
  // Garantie légale
  legalWarranty: 'Garantie Légale',
  legalWarrantyText: 'Conformément à la législation belge, Ktran est tenue par la garantie légale de conformité pour les travaux réalisés. En cas de défaut de conformité, vous disposez d\'un délai de 2 ans à compter de la réception des travaux pour faire valoir vos droits.',
  
  // Résolution alternative des litiges
  alternativeDisputeResolution: 'Résolution Alternative des Litiges',
  alternativeDisputeResolutionText: 'Conformément au Règlement (UE) n° 524/2013, vous avez la possibilité de recourir à la plateforme européenne de règlement en ligne des litiges (RLL) :',
  odrPlatform: '🌐 Plateforme ODR',
  odrPlatformUrl: 'https://ec.europa.eu/consumers/odr',
  odrPlatformText: 'Cette plateforme permet aux consommateurs de l\'UE de résoudre leurs litiges en ligne avec des professionnels.',
  
  mediationService: '🤝 Service de Médiation',
  mediationServiceText: 'En cas de litige, vous pouvez également contacter le Service de Médiation pour le Consommateur :',
  mediationAddress: 'North Gate II, Boulevard du Roi Albert II 8, boîte 1, 1000 Bruxelles',
  mediationWebsite: 'www.mediationconsommateur.be',
  
  // Propriété intellectuelle
  intellectualPropertySection: 'Propriété Intellectuelle',
  intellectualPropertySectionText1: 'Tous les éléments du Site (structure, textes, images, logos, vidéos, sons, bases de données, logiciels, etc.) sont la propriété exclusive de Ktran ou font l\'objet d\'une licence d\'utilisation.',
  intellectualPropertySectionText2: 'Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de Ktran.',
  
  authorizedUse: '✅ Utilisation Autorisée',
  authorizedUseText: 'Vous êtes autorisé à consulter le Site et à imprimer des pages pour votre usage personnel et privé, à condition de ne pas supprimer les mentions de propriété intellectuelle.',
  
  intellectualPropertySectionText3: 'Toute exploitation non autorisée du site ou de l\'un quelconque des éléments qu\'il contient sera considérée comme constitutive d\'une contrefaçon et poursuivie conformément aux dispositions des articles L.335-2 et suivants du Code de Propriété Intellectuelle.',
  
  // Responsabilité
  responsibilitySection: 'Limitation de Responsabilité',
  responsibilitySectionText1: 'Ktran ne pourra être tenue responsable des dommages directs et indirects causés au matériel de l\'utilisateur, lors de l\'accès au Site, et résultant soit de l\'utilisation d\'un matériel ne répondant pas aux spécifications indiquées, soit de l\'apparition d\'un bug ou d\'une incompatibilité.',
  responsibilitySectionText2: 'Ktran décline toute responsabilité concernant :',
  
  responsibilityList1: '• Les interruptions ou dysfonctionnements du Site',
  responsibilityList2: '• Les erreurs ou omissions dans le contenu du Site',
  responsibilityList3: '• Les dommages résultant d\'une intrusion frauduleuse d\'un tiers',
  responsibilityList4: '• Les virus informatiques',
  responsibilityList5: '• Le contenu des sites tiers vers lesquels le Site renvoie',
  responsibilityList6: '• L\'utilisation frauduleuse ou abusive du Site par l\'utilisateur',
  
  forceMajeure: '⚡ Force Majeure',
  forceMajeureText: 'Ktran ne sera pas responsable en cas de force majeure ou d\'événements hors de son contrôle (catastrophes naturelles, grèves, interruption du réseau, etc.).',
  
  // Liens hypertextes
  hyperlinksSection: 'Liens Hypertextes',
  hyperlinksSectionText1: 'Le Site peut contenir des liens hypertextes vers d\'autres sites internet. Ktran n\'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu, leur disponibilité ou leur politique de confidentialité.',
  hyperlinksSectionText2: 'La création de liens hypertextes vers le Site nécessite une autorisation écrite préalable de Ktran. Cette autorisation peut être révoquée à tout moment.',
  
  // Protection des données
  dataProtectionSection: 'Protection des Données Personnelles',
  dataProtectionSectionText1: 'Les données personnelles collectées via le Site sont traitées conformément à notre',
  dataProtectionSectionText2: 'et au Règlement Général sur la Protection des Données.',
  dataProtectionSectionText3: 'Vous disposez d\'un droit d\'accès, de rectification, d\'effacement, de limitation, de portabilité et d\'opposition concernant vos données personnelles. Pour exercer ces droits, contactez-nous à',
  
  // Cookies
  cookiesSection: 'Cookies',
  cookiesSectionText: 'Le Site utilise des cookies pour améliorer l\'expérience utilisateur et analyser le trafic. Pour plus d\'informations sur notre utilisation des cookies et comment les gérer, consultez notre',
  
  // Modification des CGU
  termsModification: 'Modification des Conditions',
  termsModificationText1: 'Ktran se réserve le droit de modifier les présentes CGU à tout moment. Les modifications entrent en vigueur dès leur publication sur le Site. Les utilisateurs sont invités à consulter régulièrement cette page pour prendre connaissance des éventuelles modifications.',
  termsModificationNote: 'L\'utilisation du Site après publication des modifications vaut acceptation de ces modifications.',
  
  // Droit applicable
  applicableLawSection: 'Droit Applicable et Juridiction Compétente',
  applicableLawSectionText1: 'Les présentes CGU sont régies par le droit belge et européen.',
  applicableLawSectionText2: 'En cas de litige et à défaut d\'accord amiable, le litige sera porté devant les tribunaux compétents de Bruxelles, Belgique.',
  
  amicableSettlement: '🤝 Règlement Amiable',
  amicableSettlementText: 'Avant toute action en justice, les parties s\'engagent à rechercher une solution amiable. En cas d\'échec, vous pouvez également recourir à la médiation ou à toute autre méthode alternative de règlement des litiges.',
  
  contactUsSection: 'Nous Contacter',
  contactUsSectionText: 'Pour toute question concernant ces conditions d\'utilisation :',

  // ========== POLITIQUE DES COOKIES ==========
  cookiePolicyTitle: 'Politique des Cookies',
  cookiePolicyDescription: 'Informations sur l\'utilisation des cookies sur notre site',
  
  // Introduction
  whatIsCookie: 'Qu\'est-ce qu\'un Cookie ?',
  cookieDefinition: 'Un cookie est un petit fichier texte stocké sur votre appareil (ordinateur, tablette, smartphone) lorsque vous visitez un site web. Les cookies permettent au site de mémoriser vos actions et préférences pendant une certaine période, afin que vous n\'ayez pas à les ressaisir à chaque visite ou lors de la navigation entre les pages.',
  
  // Types de cookies
  cookieTypesTitle: 'Types de Cookies que Nous Utilisons',
  
  // Cookies essentiels
  essentialCookiesTitle: '1. Cookies Strictement Nécessaires',
  essentialCookiesDesc: 'Ces cookies sont indispensables au fonctionnement du site et ne peuvent pas être désactivés. Ils sont généralement établis en réponse à des actions que vous effectuez (connexion, remplissage de formulaires).',
  
  examples: 'Exemples',
  sessionCookies: 'Cookies de session (authentification administrateur)',
  securityCookies: 'Cookies de sécurité (protection CSRF)',
  languageCookies: 'Cookies de préférence de langue',
  
  duration: 'Durée',
  sessionOrOneYear: 'Session ou jusqu\'à 1 an',
  
  consentRequired: 'Consentement requis',
  no: 'Non',
  yes: 'Oui',
  necessaryForOperation: 'nécessaires au fonctionnement',
  
  // Cookies fonctionnels
  functionalCookiesTitle: '2. Cookies Fonctionnels',
  functionalCookiesDesc: 'Ces cookies permettent d\'améliorer les fonctionnalités du site et de le personnaliser (mémorisation de vos préférences).',
  
  formPreferences: 'Mémorisation des choix de formulaire',
  displayPreferences: 'Préférences d\'affichage',
  navigationSettings: 'Paramètres de navigation',
  upTo13Months: 'Jusqu\'à 13 mois',
  
  // Cookies analytiques
  analyticsCookiesTitle: '3. Cookies Analytiques',
  analyticsCookiesDesc: 'Ces cookies nous permettent de comprendre comment les visiteurs utilisent notre site, afin d\'améliorer l\'expérience utilisateur.',
  
  collectedInfo: 'Informations collectées',
  trafficSource: 'Source du trafic',
  navigationBehavior: 'Comportement de navigation',
  anonymizedDemographics: 'Données démographiques anonymisées',
  
  // Cookies marketing
  marketingCookiesTitle: '4. Cookies Marketing (Non Utilisés Actuellement)',
  marketingCookiesDesc: 'Ktran n\'utilise actuellement aucun cookie marketing ou publicitaire ciblé. Si cela devait changer, nous vous en informerions et demanderions votre consentement explicite.',
  
  // Cookies tiers
  thirdPartyCookies: 'Cookies de Tiers',
  thirdPartyCookiesDesc: 'Notre site peut utiliser des services tiers qui placent leurs propres cookies :',
  
  googleMaps: 'Google Maps',
  googleMapsDesc: 'Utilisé pour afficher des cartes interactives',
  
  hosting: 'Hébergement',

  note: 'Note',
  thirdPartyNote: 'Nous ne contrôlons pas les cookies placés par ces services tiers. Nous vous recommandons de consulter leurs politiques de confidentialité respectives.',
  
  // Gestion des cookies
  manageCookiesTitle: 'Comment Gérer Vos Cookies ?',
  
  viaBrowser: '1. Via Votre Navigateur',
  browserConfigDesc: 'Vous pouvez configurer votre navigateur pour accepter ou refuser les cookies. Voici les liens vers les instructions pour les navigateurs les plus courants :',
  
  chrome: 'Google Chrome',
  firefox: 'Mozilla Firefox',
  safari: 'Safari',
  edge: 'Microsoft Edge',
  opera: 'Opera',
  
  // Conséquences du refus
  refusalConsequences: 'Conséquences du Refus des Cookies',
  refusalConsequencesDesc: 'Si vous choisissez de désactiver les cookies, certaines fonctionnalités du site peuvent ne pas fonctionner correctement :',
  
  cannotStayLoggedIn: '• Impossibilité de rester connecté (zone administrateur)',
  lossOfPreferences: '• Perte de vos préférences de navigation',
  formsNotSubmitting: '• Formulaires ne se soumettant pas correctement',
  degradedExperience: '• Expérience utilisateur dégradée',
  
  // Suppression des cookies
  deletingCookies: '2. Suppression des Cookies Existants',
  deletingCookiesDesc: 'Vous pouvez supprimer les cookies déjà stockés sur votre appareil à tout moment via les paramètres de votre navigateur. Cette action supprimera tous les cookies, y compris ceux nécessaires au bon fonctionnement du site.',
  
  // Durée de conservation
  retentionPeriodTitle: 'Durée de Conservation des Cookies',
  
  cookieType: 'Type de Cookie',
  maxDuration: 'Durée Maximale',
  
  sessionCookiesType: 'Cookies de session',
  untilBrowserClose: 'Jusqu\'à fermeture du navigateur',
  
  essentialCookiesType: 'Cookies strictement nécessaires',
  twelveMonths: '12 mois',
  
  functionalCookiesType: 'Cookies fonctionnels',
  thirteenMonths: '13 mois',
  
  analyticsCookiesType: 'Cookies analytiques',
  
  gdprComplianceNote: 'Conformément à la directive ePrivacy et au RGPD, la durée de conservation des cookies ne peut excéder 13 mois.',
  
  // Base légale
  legalBasisTitle: 'Base Légale et Conformité',
  legalBasisDesc: 'Notre utilisation des cookies est conforme aux réglementations suivantes :',
  
  gdprFull: 'Règlement européen 2016/679 - Protection des données personnelles',
  ePrivacyDirective: 'Directive ePrivacy',
  belgianLaw: 'Loi belge du 13 juin 2005 relative aux communications électroniques',
  
  consentDesc: 'Conformément à la législation, nous demandons votre consentement avant de déposer des cookies non essentiels. Vous pouvez retirer votre consentement à tout moment.',
  
  // Tableau détaillé des cookies
  detailedCookieTable: 'Liste Détaillée des Cookies',
  
  cookieName: 'Nom du Cookie',
  cookiePurpose: 'Finalité',
  cookieDuration: 'Durée',
  cookieCategory: 'Catégorie',
  
  // Contact
  questionsAboutCookies: 'Questions sur les Cookies ?',
  contactUsForQuestions: 'Pour toute question concernant notre utilisation des cookies, contactez-nous :',

  // ========== PROTECTION DES DONNÉES ==========
  dataProtectionTitle: 'Protection des Données',
  dataProtectionDescription: 'Conformité RGPD et mesures de sécurité pour vos données personnelles',
  
  // Introduction
  gdprCommitment: 'Notre Engagement envers le RGPD',
  gdprCommitmentText1: 'Ktran (N° TVA : BE0729535515) s\'engage pleinement à protéger vos données personnelles et à respecter le Règlement Général sur la Protection des Données (RGPD - UE 2016/679) ainsi que la législation belge relative à la protection de la vie privée.',
  gdprCommitmentText2: 'Cette page détaille les mesures techniques et organisationnelles que nous mettons en œuvre pour garantir la sécurité et la confidentialité de vos données.',
  
  // Principes RGPD
  gdprPrinciples: 'Principes Fondamentaux du RGPD',
  gdprPrinciplesText: 'Nous respectons les six principes fondamentaux du RGPD dans le traitement de vos données :',
  
  lawfulnessTransparency: '1. Licéité et Transparence',
  lawfulnessTransparencyDesc: 'Traitement licite, loyal et transparent. Vous êtes informé de l\'utilisation de vos données.',
  
  purposeLimitation: '2. Limitation des Finalités',
  purposeLimitationDesc: 'Collecte pour des finalités déterminées, explicites et légitimes uniquement.',
  
  dataMinimization: '3. Minimisation des Données',
  dataMinimizationDesc: 'Collecte limitée aux données strictement nécessaires à nos services.',
  
  accuracy: '4. Exactitude',
  accuracyDesc: 'Données exactes et tenues à jour. Possibilité de rectification à tout moment.',
  
  storageLimitation: '5. Limitation de la Conservation',
  storageLimitationDesc: 'Conservation limitée dans le temps selon les finalités et obligations légales.',
  
  integrityConfidentiality: '6. Intégrité et Confidentialité',
  integrityConfidentialityDesc: 'Sécurité appropriée contre le traitement non autorisé ou illicite.',
  
  // Mesures de sécurité techniques
  technicalSecurityMeasures: 'Mesures de Sécurité Techniques',
  technicalSecurityMeasuresText: 'Nous mettons en œuvre des mesures de sécurité techniques avancées pour protéger vos données :',
  
  // Chiffrement
  dataEncryption: '🔐 Chiffrement des Données',
  
  sslTls: 'SSL/TLS (HTTPS)',
  sslTlsDesc: 'Toutes les communications entre votre navigateur et nos serveurs sont chiffrées',
  
  encryptionAtRest: 'Chiffrement au repos',
  encryptionAtRestDesc: 'Les données sensibles sont chiffrées dans la base de données',
  
  secureProtocols: 'Protocoles sécurisés',
  secureProtocolsDesc: 'Utilisation de TLS 1.3 pour les communications',
  
  // Contrôle d'accès
  accessControl: '🔑 Contrôle d\'Accès',
  
  strongAuthentication: 'Authentification forte',
  strongAuthenticationDesc: 'Accès administratif protégé par mot de passe sécurisé',
  
  leastPrivilege: 'Principe du moindre privilège',
  leastPrivilegeDesc: 'Accès limité aux seules personnes autorisées',
  
  secureSessions: 'Sessions sécurisées',
  secureSessionsDesc: 'Expiration automatique des sessions inactives',
  
  logging: 'Journalisation',
  loggingDesc: 'Traçabilité des accès aux données sensibles',
  
  // Infrastructure sécurisée
  secureInfrastructure: '☁️ Infrastructure Sécurisée',
  
  certifiedHosting: 'Hébergement certifié',
  certifiedHostingDesc: 'Serveurs hébergés dans l\'UE (conformité RGPD)',
  
  firewall: 'Pare-feu',
  firewallDesc: 'Protection contre les intrusions et attaques',
  
  automaticBackups: 'Sauvegardes automatiques',
  automaticBackupsDesc: 'Sauvegardes quotidiennes chiffrées et sécurisées',
  
  monitoring247: 'Surveillance 24/7',
  monitoring247Desc: 'Monitoring continu de la sécurité',
  
  // Protection contre les menaces
  threatProtection: '🛡️ Protection contre les Menaces',
  
  antiMalware: 'Anti-malware',
  antiMalwareDesc: 'Détection et blocage des logiciels malveillants',
  
  ddosProtection: 'Protection DDoS',
  ddosProtectionDesc: 'Défense contre les attaques par déni de service',
  
  inputValidation: 'Validation des entrées',
  inputValidationDesc: 'Protection contre les injections SQL et XSS',
  
  regularUpdates: 'Mises à jour régulières',
  regularUpdatesDesc: 'Application rapide des correctifs de sécurité',
  
  // Mesures organisationnelles
  organizationalMeasures: 'Mesures Organisationnelles',
  organizationalMeasuresText: 'Au-delà des mesures techniques, nous avons mis en place des procédures organisationnelles strictes :',
  
  internalPrivacyPolicy: '📋 Politique de Confidentialité Interne',
  internalPrivacyPolicyDesc: 'Tous les collaborateurs ayant accès aux données sont formés et sensibilisés à la protection des données personnelles et sont tenus par une obligation de confidentialité.',
  
  impactAnalysis: '🔍 Analyse d\'Impact (PIA)',
  impactAnalysisDesc: 'Nous réalisons des analyses d\'impact sur la protection des données pour les traitements présentant des risques élevés.',
  
  completeDocumentation: '📝 Documentation Complète',
  completeDocumentationDesc: 'Registre des activités de traitement tenu à jour conformément à l\'article 30 du RGPD.',
  
  incidentManagement: '🚨 Procédure de Gestion des Incidents',
  incidentManagementDesc: 'Plan de réponse aux violations de données avec notification à l\'autorité de contrôle dans les 72 heures si nécessaire.',
  
  // Transferts de données
  dataTransfers: 'Transferts de Données',
  dataTransfersText1: 'Vos données personnelles sont hébergées et traitées au sein de l\'Union Européenne, garantissant ainsi le plus haut niveau de protection.',
  
  euHosting: '🇪🇺 Hébergement dans l\'UE',
  euHostingList1: '✓ Serveurs situés dans l\'Union Européenne',
  euHostingList2: '✓ Conformité totale avec le RGPD',
  euHostingList3: '✓ Aucun transfert vers des pays tiers sans garanties appropriées',
  euHostingList4: '✓ Sous-traitants certifiés et conformes RGPD',
  
  transferNote: 'Si un transfert de données hors UE devait être nécessaire à l\'avenir, nous nous assurerions qu\'il soit encadré par des garanties appropriées (clauses contractuelles types de la Commission européenne, décision d\'adéquation, etc.) et vous en informerions.',
  
  // Sous-traitants
  subcontractorsPartners: 'Sous-traitants et Partenaires',
  subcontractorsPartnersText: 'Nous travaillons uniquement avec des sous-traitants qui offrent des garanties suffisantes en matière de protection des données :',
  
  subcontractor: 'Sous-traitant',
  service: 'Service',
  location: 'Localisation',
  compliance: 'Conformité',
  
  vercel: 'Vercel',
  webHosting: 'Hébergement web',
  eu: 'UE',
  gdprCompliant: '✓ RGPD',

  emailService: 'Service e-mail transactionnel',
  
  subcontractingContracts: 'Contrats de Sous-traitance',
  subcontractingContractsText: 'Tous nos sous-traitants sont liés par des contrats conformes à l\'article 28 du RGPD, garantissant la sécurité et la confidentialité de vos données.',
  
  // Exercice des droits
  exercisingYourRights: 'Exercice de Vos Droits',
  exercisingYourRightsText: 'Vous disposez de droits sur vos données personnelles. Voici comment les exercer :',
  
  howToMakeRequest: '📧 Comment Faire une Demande ?',
  
  protectionByEmail: '1. Par e-mail',
  protectionByPhone: '2. Par téléphone',
  protectionByMail: '3. Par courrier',
  
  protectionInformationToProvide: 'Informations à Fournir',
  
  // Violations de données
  dataBreachManagement: 'Gestion des Violations de Données',
  dataBreachManagementText: 'En cas de violation de données personnelles susceptible d\'engendrer un risque élevé pour vos droits et libertés, nous nous engageons à :',
  
  rapidNotification: '⏰ Notification Rapide',
  rapidNotificationDesc: 'Notification à l\'Autorité de Protection des Données (APD) dans les 72 heures',
  
  affectedPersonsNotification: '📢 Information des Personnes Concernées',
  affectedPersonsNotificationDesc: 'Vous serez informé sans délai si la violation présente un risque élevé pour vous',
  
  correctiveMeasures: '🔧 Mesures Correctives',
  correctiveMeasuresDesc: 'Mise en place immédiate de mesures pour limiter les conséquences',
  
  documentation: '📋 Documentation',
  documentationDesc: 'Tenue d\'un registre des violations conformément à l\'article 33 du RGPD',
  
  // Autorité de contrôle
  supervisoryAuthority: 'Autorité de Contrôle',
  supervisoryAuthorityText: 'Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation auprès de l\'autorité de contrôle belge :',

  apdTitle: 'Autorité de Protection des Données (APD)',

  // Contact
  contactUsDataProtection: 'Nous Contacter',
  contactUsDataProtectionText: 'Pour toute question concernant la protection de vos données personnelles :',
  
  dataControllerResponsible: 'Responsable du traitement',
  
  // Cookie Consent
  cookieTitle: 'Nous utilisons des cookies',
  cookieMessage: 'Nous utilisons des cookies pour améliorer votre expérience sur notre site. En continuant à naviguer, vous acceptez notre utilisation des cookies.',
  cookieAccept: 'Accepter',
  cookieDecline: 'Refuser',
  cookieLearnMore: 'En savoir plus',
};